/**
 * Angular imports
 */
import { Component, Input } from '@angular/core';

/**
 * Service imports
 */
import { MultiLangService } from '../../../dataservices/master-service/multi-lang.service';

/**
 * CommentText Component
 */
@Component({
  selector: 'app-comment-text',
  templateUrl: './comment-text.component.html',
  styleUrls: ['./comment-text.component.scss']
})
export class CommentTextComponent {
  @Input() cmt;
  @Input() id;
  public see_more = false;

  /**
   * Necessary instances.
   */
  constructor(public mls: MultiLangService) { }

  /**
   * see More
   */
  seeMore(): void {
    this.see_more = true;
  }

  /**
   * see Less
   */
  seeLess(): void {
    this.see_more = false;
  }
}
